<template>
    <div class="wd-chart">
        <div class="wd-rows">
            <div v-for="row in rows" :key="row.key" class="wd-row">
                <span class="wd-label">{{ row.label }}</span>
                <div class="wd-track">
                    <span v-for="tick in ticks" :key="tick.value" class="wd-grid" :style="{ left: tick.pos + '%' }" />
                    <div class="wd-bar wd-bar--avg" :style="{ width: barWidth(row.avgPct), background: row.color }" />
                    <div class="wd-bar wd-bar--today" :style="{ width: barWidth(row.pct), background: row.color }" />
                </div>
                <span class="wd-value" :style="{ color: row.count ? row.color : null }">
                    {{ row.count }} · {{ Math.round(row.pct) }}%
                </span>
            </div>
        </div>
        <div class="wd-row wd-axis">
            <span class="wd-label" />
            <div class="wd-track">
                <span v-for="tick in ticks" :key="tick.value" class="wd-tick" :style="{ left: tick.pos + '%' }">
                    {{ tick.value }}%
                </span>
            </div>
            <span class="wd-value" />
        </div>
        <div class="wd-legend">
            <span class="wd-leg"><i class="wd-leg-bar" />{{ $t('common.today') }}</span>
            <span class="wd-leg"><i class="wd-leg-bar wd-leg-bar--avg" />{{ $t('statistics.period_average') }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WellnessDistributionChart',
    props: {
        rows: {
            type: Array,
            default: () => [],
        },
        max: {
            type: Number,
            default: 30,
        },
    },
    computed: {
        axisMax(vm = this) {
            return Math.max(10, Number(vm.max) || 0)
        },
        ticks(vm = this) {
            const step = vm.axisMax > 60 ? 20 : 10
            const list = []
            for (let value = 0; value <= vm.axisMax; value += step) {
                list.push({ value, pos: value / vm.axisMax * 100 })
            }
            return list
        },
    },
    methods: {
        barWidth(pct) {
            const value = Math.max(0, Number(pct) || 0)
            return `${Math.min(100, value / this.axisMax * 100)}%`
        },
    },
}
</script>

<style scoped>
.wd-chart {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.wd-rows {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 6px;
    min-height: 0;
}

.wd-row {
    display: flex;
    align-items: center;
    gap: 8px;
}

.wd-label {
    flex: 0 0 62px;
    font-size: 10px;
    font-weight: 600;
    color: var(--v-txtSecondary-base);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.wd-track {
    position: relative;
    flex: 1;
    min-width: 0;
    height: 14px;
}

.wd-grid {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 0;
    border-left: 1px solid var(--v-outline-base);
}

.wd-grid:first-child {
    border-left-color: var(--v-outline2-base);
}

.wd-bar {
    position: absolute;
    left: 0;
    border-radius: 3px;
}

.wd-bar--avg {
    top: 0;
    height: 14px;
    opacity: 0.25;
}

.wd-bar--today {
    top: 3px;
    height: 8px;
}

.wd-value {
    flex: 0 0 56px;
    text-align: right;
    font-size: 10px;
    font-weight: 700;
    color: var(--v-txtMuted-base);
    white-space: nowrap;
}

.wd-axis {
    flex-shrink: 0;
    margin-top: 4px;
}

.wd-axis .wd-track {
    height: 12px;
}

.wd-tick {
    position: absolute;
    top: 0;
    transform: translateX(-50%);
    font-size: 8px;
    font-weight: 500;
    color: var(--v-txtMuted-base);
}

.wd-legend {
    display: flex;
    gap: 16px;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 4px;
}

.wd-leg {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 10px;
    font-weight: 600;
    color: var(--v-txtMuted-base);
}

.wd-leg-bar {
    width: 14px;
    height: 8px;
    border-radius: 2px;
    background: var(--v-txtMuted-base);
    flex-shrink: 0;
}

.wd-leg-bar--avg {
    opacity: 0.3;
}
</style>
